import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  public isLoading: BehaviorSubject<boolean>;
  loadingMap: Map<string, number> = new Map<string, number>();
  constructor() {
    this.isLoading = new BehaviorSubject<boolean>(false);
  }

  showLoadingComponent(url: string): void {
    let value: number | undefined = this.loadingMap.get(url);
    if (!value) {
      value = 0;
    }
    this.loadingMap.set(url, value + 1);
    if (!this.isLoading.value) {
      this.isLoading.next(true);
    }
  }

  closeLoadingComponent(url: string): void {
    if (this.loadingMap.has(url)) {
      const value: number | undefined = this.loadingMap.get(url);
      if (value === 1) {
        this.loadingMap.delete(url);
      } else {
        this.loadingMap.set(url, (value as number) - 1);
      }
    }
    if (this.isLoading.value && this.loadingMap.size === 0) {
      if (this.isLoading.value) {
        this.isLoading.next(false);
      }
    }
  }
}
